import type { IComponentController } from "angular";

export default class FindUserByCodeComponentController implements IComponentController {}
